import React from 'react'
import { Dropdown } from 'react-bootstrap'
import {
  PrimaryButton,
  DropdownPrimaryButtonMenu,
  DropdownPrimaryButtonMenuItem,
} from './DropdownPrimaryButton.styles'

export interface DropdownButtonItems {
  name: string | React.ReactNode
  onClick: (e: React.MouseEvent) => void
  disabled?: boolean
  className?: string
}

export interface DropdownButtonProps {
  label: string | React.ReactNode
  items: DropdownButtonItems[]
}

export const DropdownPrimaryButton = ({
  label,
  items,
}: DropdownButtonProps): JSX.Element => {
  return (
    <Dropdown>
      <Dropdown.Toggle as={PrimaryButton} id="dropdown-basic">
        {label ? label : 'Select Option'}
      </Dropdown.Toggle>

      <Dropdown.Menu as={DropdownPrimaryButtonMenu}>
        {items.map((item, index) => (
          <Dropdown.Item
            key={index}
            onClick={item.disabled ? undefined : item.onClick}
            as={DropdownPrimaryButtonMenuItem}
            className={item.className}
          >
            {item.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  )
}
